import { useRef, useEffect } from "react";

interface SandboxedHtmlProps {
  html: string;
  className?: string;
}

/**
 * Renders arbitrary HTML inside a Shadow DOM so its styles
 * cannot leak into the rest of the application.
 */
export function SandboxedHtml({ html, className }: SandboxedHtmlProps) {
  const hostRef = useRef<HTMLDivElement>(null);
  const shadowRef = useRef<ShadowRoot | null>(null);

  useEffect(() => {
    if (!hostRef.current) return;
    if (!shadowRef.current) {
      shadowRef.current = hostRef.current.attachShadow({ mode: "open" });
    }
    shadowRef.current.innerHTML = `
      <style>
        :host { display: block; }
        * { max-width: 100%; box-sizing: border-box; }
        body, html { margin: 0; padding: 0; }
        img { height: auto; }
        pre { white-space: pre-wrap; overflow-x: auto; }
        a { color: hsl(var(--primary, 220 90% 56%)); }
      </style>
      <div style="font-family: sans-serif; font-size: 14px; line-height: 1.6; color: inherit; word-break: break-word;">
        ${html}
      </div>
    `;
  }, [html]);

  return <div ref={hostRef} className={className} />;
}
